export default __webpack_public_path__ + "static/media/1.abde750f.png";